import React, { useEffect } from 'react';
import Config from '../../../config/Config';
import { connect } from 'react-redux';
import { myCoursesFilter } from '../../../utils/const';
import { fetchInstruction } from '../../../redux/myCourse/myCourse.actions';
import {
	toggleMicPermission,
	startAttempt,
} from '../../../redux/testPage/testPage.actions';
import {
	setErrorMsg,
	setShowPermitMic,
} from '../../../redux/utilities/utils.actions';
import { noInternet } from '../../../utils/const';
import Zoom from '../../utils/animations/zoom';
import Card from 'react-bootstrap/Card';
import moment from 'moment';
import {
	minToMs,
	dateDiff,
	getLocalTime,
	setRevealTimer,
	getParameterByName,
} from '../../../utils/commonFunctions';
import { tagEvent } from '../../../utils/tagManager';
import ScheduleCallCard from '../ielts/scheduleCallCard';
import SubmitTaskCard from '../ielts/submitTaskCard';

const getRevealTime = (reveal_date, reveal_time) => {
	let revealDate = `${reveal_date} ${reveal_time}`;
	if (moment.tz.guess() !== 'Asia/Calcutta') {
		revealDate = getLocalTime(revealDate);
		reveal_time = moment(revealDate).format('HH:mm:ss');
		reveal_date = moment(revealDate).format('DD-MM-YYYY');
		return dateDiff('milliseconds', revealDate);
	} else {
		return dateDiff('milliseconds', revealDate);
	}
};
const getElementCardValues = (
	startAttempt,
	completedElements,
	elementDetails,
	fetchInstruction,
	courseId,
	product_id,
	grant_name,
	product_name,
	userId,
	course_name,
	canScheduleCall,
	warningOnScheduleCall,
) => {
	const {
		completed,
		completion_count,
		elementID,
		element_description,
		element_lock_message,
		element_lock_status,
		element_name,
		element_theme,
		element_type,
		is_adaptive_mystery,
		percentcomplete,
		possible,
		review_answers,
		Coach_call,
		Coach_call_label,
		call_status,
	} = elementDetails;


	let { reveal_date, reveal_time } = elementDetails;
	let { themeclass, adaptiveTextClass, themefilterclass } = myCoursesFilter[
		element_theme
	];
	let isCourseCompleted = '';
	let instructionLink = {};
	let elemNameClass = 'col-xs-6 col-lg-12 col-md-12';
	let adaptiveNameClass = `${adaptiveTextClass} adaptive-title`;
	let completedItems = '';
	let certificateClass = '';
	let typeBottomBlock = '';
	let typeSpecific = '';
	let redoText = 'GO';

	var flipClass = '';
	var lockedClass = '';
	var lockedPopupClass = '';
	var lockedPopupDiv = '';

	// let reveal_date = '2021-03-11';
	// let reveal_time = '09:36:20';
	let reveal = getRevealTime(reveal_date, reveal_time);

	if (
		percentcomplete !== 100 &&
		(element_lock_status || reveal > minToMs(0.5))
	) {
		({
			lockedClass,
			lockedPopupClass,
			flipClass,
			lockedPopupDiv,
		} = processLockedCourse(
			completion_count,
			completedElements,
			element_lock_message,
			reveal_date,
			reveal_time,
			product_id,
			grant_name,
			product_name,
			userId,
			courseId,
			course_name,
		));
	}

	if (percentcomplete === 100) {
		isCourseCompleted = 'panel-course-light';
		redoText = 'REDO';
	}

	if (element_type === 'F') {
		instructionLink =
			percentcomplete === 100 && !review_answers
				? () => {}
				: () => {
						percentcomplete === 100
							? fetchInstruction(elementID, courseId, true)
							: fetchInstruction(elementID, courseId);
				  };

		if (!is_adaptive_mystery) {
			themeclass = 'panel-course-adaptive-completed ';
			typeBottomBlock = getBottomBlock(
				redoText,
				'board_red',
				review_answers,
				true,
			);
			typeSpecific = (
				<div className="row">
					<div className={elemNameClass}>
						<div className="course-desc adaptive-text-red">{element_name}</div>
					</div>
				</div>
			);
		} else {
			adaptiveNameClass = '';
			elemNameClass = 'col-xs-8 col-lg-7 col-md-7 text-left';
			themeclass = 'panel-course-default ';
			redoText = percentcomplete === 100 ? 'REVIEW' : redoText;
			typeBottomBlock = getBottomBlock(redoText, 'board', review_answers);
			typeSpecific = (
				<div className="row courseblock">
					<div className="col-xs-9 col-lg-6 col-md-9 text-left">
						{getCourseDescBlock(element_description)}
					</div>
				</div>
			);
			completedItems = setCompletedItem(completed, possible);
		}
	} else if (element_type === 'S') {
		instructionLink =
			percentcomplete === 100 && !review_answers
				? () => {}
				: () => {
						percentcomplete === 100
							? fetchInstruction(elementID, courseId, true)
							: fetchInstruction(elementID, courseId);
				  };

		if (!is_adaptive_mystery) {
			themeclass = 'panel-course-adaptive-completed ';
			typeBottomBlock = getBottomBlock(
				redoText,
				'board_red',
				review_answers,
				true,
			);
			typeSpecific = (
				<div className="row">
					<div className={elemNameClass}>
						{setImg('certificate', 'certificateimg')}
					</div>
				</div>
			);
		} else {
			adaptiveNameClass = '';
			themeclass = 'panel-course-white ';
			redoText = percentcomplete === 100 ? 'REVIEW' : redoText;
			typeBottomBlock = getBottomBlock(redoText, '', review_answers, false);
			typeSpecific = (
				<div className="row">
					<div className={elemNameClass}>
						{setImg('certificate', 'certificateimg')}
					</div>
				</div>
			);
			completedItems = setCompletedItem(completed, possible);
			elemNameClass = 'col-xs-8 col-lg-7 col-md-7 text-left';
		}
	} else if (element_type === 'W') {
		instructionLink = () => {
			fetchInstruction(elementID, courseId);
		};

		if (!is_adaptive_mystery) {
			typeSpecific = (
				<div className="row">
					<div className={elemNameClass}>
						{getCourseDescBlock(element_description, adaptiveTextClass)}
					</div>
				</div>
			);
		} else {
			adaptiveNameClass = '';
			elemNameClass = 'col-xs-8 col-lg-7 col-md-7 text-left';
			typeBottomBlock = getBottomBlock(redoText, '', review_answers);
			typeSpecific = (
				<div className="row courseblock ">
					<div className="col-xs-9 col-lg-9 col-md-9 text-left">
						{getCourseDescBlock(element_description)}
					</div>
				</div>
			);
		}
	} else if (element_type === 'A') {
		adaptiveNameClass = 'adaptive-title';
		lockedClass = '';

		instructionLink = () => {
			fetchInstruction(elementID, courseId);
		};

		if (element_lock_status) {
			themeclass = 'panel-course-adaptive-lock';
			typeSpecific = (
				<div className="row adaptive-lock-icons">
					<div className={elemNameClass}>{setImg('lock-icon')}</div>
				</div>
			);
		} else {
			themeclass = 'panel-course-adaptive-open';
			typeSpecific = (
				<div className="row">
					<div className={elemNameClass}>{setImg('mystery', '', true)}</div>
				</div>
			);
			typeBottomBlock = getBottomBlock('start', '', review_answers, false, false);
		}
	} else if (element_type === 'D') {
		instructionLink = () => {
			startAttempt(0, 246);
		};

		adaptiveNameClass = '';
		elemNameClass = 'col-xs-8 col-lg-7 col-md-7 text-left';
		themeclass = 'panel-course-default ';
		redoText = percentcomplete === 100 ? 'REVIEW' : redoText;
		typeBottomBlock = getBottomBlock(redoText, 'board', review_answers);
		typeSpecific = (
			<div className="row courseblock">
				<div className="col-xs-9 col-lg-9 col-md-9 text-left">
					{getCourseDescBlock(element_description)}
				</div>
			</div>
		);
		//completedItems = setCompletedItem(completed, possible);
	}
	return {
		flipClass,
		themeclass,
		isCourseCompleted,
		lockedClass,
		lockedPopupClass,
		instructionLink,
		elemNameClass,
		adaptiveNameClass,
		completedItems,
		certificateClass,
		typeBottomBlock,
		lockedPopupDiv,
		themefilterclass,
		typeSpecific,
		Coach_call,
	};
};

const processLockedCourse = (
	completion_count,
	completedElements,
	element_lock_message,
	reveal_date,
	reveal_time,
	product_id,
	grant_name,
	product_name,
	userId,
	courseId,
	course_name,
) => {
	let unlockHintArray = [];
	let unlockHint = '';

	if (completion_count > completedElements) {
		let moreActReq = completion_count - completedElements;
		moreActReq > 1
			? unlockHintArray.push('complete any ' + moreActReq + ' activites')
			: unlockHintArray.push('complete any ' + moreActReq + ' activity');
	}

	let { revealDate, dateReveal, timeReveal, reveal } = setRevealTimer(
		reveal_date,
		reveal_time,
	);
	reveal_date = dateReveal;
	reveal_time = timeReveal;

	if (reveal > 0) {
		unlockHintArray.push(
			`wait till ${moment(revealDate).format('D-MM-YYYY HH:mm:ss')}`,
		);
		if (
			dateDiff('milliseconds', `${reveal_date} ${reveal_time}`) < minToMs(60) &&
			dateDiff('milliseconds', `${reveal_date} ${reveal_time}`) > minToMs(0)
		) {
			let timer_element = setInterval(function () {
				if (
					dateDiff('milliseconds', `${reveal_date} ${reveal_time}`) <= minToMs(0)
				) {
					clearInterval(timer_element);
					window.location.reload();
				}
			}, 10000);
		}
	}

	if (!!element_lock_message) {
		unlockHint = element_lock_message;
	} else if (unlockHintArray.length > 0) {
		unlockHint =
			'You need to ' + unlockHintArray.join(' and ') + ' to unlock this activity';
	} else {
		unlockHint = 'Please wait for this activity to be unlocked';
	}

	if(courseId == 507)
	{
		product_id = 638
	}

	return {
		lockedClass: 'lockoverlay',
		lockedPopupClass: ' front card',
		flipClass: ' flip',
		lockedPopupDiv: (
			<div className="back card">
				{element_lock_message.toLowerCase() === 'purchase now' ? (
					<>
						<p>In order to access this module, you will need to buy the course.</p>
						<a href={`/purchase?productID=${product_id}`}>
							<button
								className="get-free-button"
								onClick={() => {
									tagEvent({
										event: 'click_locked_module',
										user_id: userId,
										product_id,
										product_name,
										grant_name: course_name,
										course_id: courseId,
										platform: 'web',
									});
								}}
							>
								{' '}
								Buy Now{' '}
							</button>
						</a>
					</>
				) : (
					<p>{unlockHint}</p>
				)}
			</div>
		),
	};
};
const getBottomBlock = (
	redoText,
	img,
	review_answers,
	isAdaptive = false,
	showImg = true,
) => {
	return (
		<div className="row courseblock adaptive_bottom_block">
			{showImg && setImg(img, isAdaptive)}
			{!review_answers && redoText === 'REVIEW' ? null : (
				<Zoom className="link-progress">{redoText}</Zoom>
			)}
		</div>
	);
};

const getCourseDescBlock = (text, otherClasses = '') => {
	return (
		<div
			className={`course-desc ${otherClasses}`}
			dangerouslySetInnerHTML={{ __html: text }}
		></div>
	);
};

const setImg = (img, imgClass = '', isAdaptive = false) => {
	return (
		<img
			src={`${Config.ASSETSPATH}img/${img}.png`}
			className={`${isAdaptive ? 'adaptive-icons' : ''} ${imgClass}`}
			alt={`${img}`}
		/>
	);
};

const setCompletedItem = (completed = 0, possible = 0) => {
	return (
		<div className="col-xs-4 col-lg-5 col-md-5 text-right">
			<span style={{ collapseor: '#000' }}>{completed}</span>/{possible}
		</div>
	);
};
const ElementList = ({
	elementDetails,
	fetchInstruction,
	courseId,
	toggleMicPermission,
	startAttempt,
	setErrorMsg,
	setShowPermitMic,
	product_id,
	grant_name,
	product_name,
	userId,
	course_name,
	warningOnScheduleCall,
}) => {
	const {
		elementID,
		element_name,
		just_for_me,
		thumbnail_image,
		completedElements,
		element_type,
		review_answers,
		percentcomplete,
		checkMic,
		Coach_call,
		Coach_call_label,
		call_status,
		task_status,
		completed,
		ielts_score,
		is_coach_call,
	} = elementDetails;

	let {
		flipClass,
		themeclass,
		isCourseCompleted,
		lockedClass,
		lockedPopupClass,
		instructionLink,
		elemNameClass,
		adaptiveNameClass,
		completedItems,
		typeBottomBlock,
		lockedPopupDiv,
		themefilterclass,
		typeSpecific,
		element_lock_status,
	} = getElementCardValues(
		startAttempt,
		completedElements,
		elementDetails,
		fetchInstruction,
		courseId,
		product_id,
		grant_name,
		product_name,
		userId,
		course_name,
		Coach_call,
		call_status,
		completed,
		ielts_score,
		is_coach_call,
	);

	const checkPermissions = (e) => {
		e.preventDefault();
		if (element_type === 'D' || !checkMic) {
			instructionLink();
		} else {
			if (navigator.mediaDevices === undefined) {
				navigator.mediaDevices = {};
			}
			if (navigator.mediaDevices.getUserMedia === undefined) {
				navigator.mediaDevices.getUserMedia = function (constraints) {
					var getUserMedia =
						navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

					if (!getUserMedia) {
						return Promise.reject(
							new Error('getUserMedia is not implemented in this browser'),
						);
					}
					return new Promise(function (resolve, reject) {
						getUserMedia.call(navigator, constraints, resolve, reject);
					});
				};
			}

			navigator.mediaDevices
				.getUserMedia({ audio: true })
				.then(function success() {
					toggleMicPermission(true);
					instructionLink();
				})
				.catch(function failure(err) {
					console.log('Mic permissions denied', err);
					setShowPermitMic(true);
					toggleMicPermission(false);
				});
		}
	};

	return (
		<>
		<Card
			className={` box course-element-card ${flipClass} ${themefilterclass} ${
				just_for_me ? `jfm` : ``
			}`}
			style={{ width: '15rem' }}
			id={`block_${elementID}`}
			key={elementID}
		>
			<div
				style={{
					backgroundImage: !!thumbnail_image ? `url(${thumbnail_image})` : '',
					backgroundSize: '140%',
					backgroundPosition: 'center',
					height: '162px',
					margin: '20px 0 27px',
					position: 'relative',
				}}
			>
				<div
					className={
						themeclass +
						' ' +
						isCourseCompleted +
						' ' +
						lockedClass +
						lockedPopupClass
					}
					style={{
						cursor: 'pointer',
						opacity: percentcomplete === 100 && !review_answers ? '0.5' : '0.8',
						pointerEvents:
							!!element_lock_status || (percentcomplete === 100 && !review_answers)
								? 'none'
								: 'auto',
					}}
					onClick={(e) => {
						!!warningOnScheduleCall
							? setErrorMsg(warningOnScheduleCall)
							: checkPermissions(e)
					}}
					onTouchStart={(e) => checkPermissions(e)}
				>
					<Card.Body>
					{courseId != 507 ? (
						<h1 className={`${just_for_me ? `ribbon_foryou` : `hideElement`}`}>
							Recommended
						</h1>
					) : (
						<h1 className="ribbon_foryou">
							{element_name}
						</h1>
					)}
						<div className="row courseblock">
						{courseId != 507 ? (
							<div className={elemNameClass}>
								<div className={adaptiveNameClass}>{element_name} </div>
							</div>
						) : null}
							{ is_coach_call ==1  && completed == 0 && ielts_score == 0 ? (
								<div 
									style={{ 
										fontSize: '11px',
										lineHeight: '20px',
										padding: '7px', 
									}}
								>Watch this webisode and score 60% to book your next Coach Call.
							    </div>
							) : null}

							{ is_coach_call == 1 && completed == 1 && ielts_score <=59 ? (
								<div 
									style={{ 
										fontSize: '12px',
										lineHeight: '20px',
										padding: '7px', 
									}}
								>You need to score 60% in this module to book your next Coach Call. 
							    </div>
							) : null}
							{completedItems}
						</div>
						{typeSpecific}
						{typeBottomBlock}
					</Card.Body>
				</div>
				{lockedPopupDiv}
			</div>
		</Card>
		{ Coach_call == 1 && call_status != 2 ? (
	   	<ScheduleCallCard elementID={elementID} />) : null
		}
		{is_coach_call == 1 && call_status == 2 && task_status == 0 && <SubmitTaskCard />}
		</>
	);
};

const mapStateToProps = (state) => {
	const {
		completedElements,
		coursedetails: { course_name } = {},
		canScheduleCall,
		warningOnScheduleCall,
	} = state.rootReducer.myCourse;
	const { courseId, userId } = state.rootReducer.loginDetails;
	const {
		productData: { product_id, product_name } = {},
	} = state.rootReducer.buyCourse;

	return {
		completedElements,
		courseId,
		userId,
		product_id,
		product_name,
		course_name,
		canScheduleCall,
		warningOnScheduleCall,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchInstruction: (elementId, courseId, completed = false) =>
			dispatch(fetchInstruction({ elementId, courseId, completed })),
		toggleMicPermission: (val) => dispatch(toggleMicPermission(val)),
		setErrorMsg: (msg) => dispatch(setErrorMsg(msg)),
		startAttempt: (courseId, elementId) =>
			dispatch(startAttempt({ courseId, elementId })),
		setShowPermitMic: (val) => dispatch(setShowPermitMic(val)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ElementList);